import { chatFocusSlice } from '../store/slices/chatFocusSlice';

export const { setChatInFocus: chatItemInFocus } = chatFocusSlice.actions;
